<template>
  <div :class="['filter-list', { '-disabled': loading }]" ref="filterList">
    <div class="plp-count-contanier">
      <button
        v-modal="{modalid:'filter'}"
        class="button -primary filter-btn"
        v-if="filterPage != 'search' && isFilterMobileWrapperPresent"
      >
        {{ filterBtn }}
      </button>
      <div class="product-ctn">
        {{
          totalFilteredResults === null || totalFilteredResults === undefined
            ? totalProductCount
            : totalFilteredResults
        }}
        {{ totalProductCountLabel }}
      </div>
    </div>
    <ul class="card-list --grid">
      <slot v-if="initialItemsLoaded" />

      <li v-for="item in items" class="card-list__item" :key="item.id">
        <card
          :type="pageType"
          :item="item"
          :search-page="isProducts && !!keyword.length"
        ></card>
      </li>
    </ul>
    <slot name="button" v-if="showLoadMoreBtn" class="loadmore"></slot>  
    </div>
</template>

<script>
import { eventBus } from 'EventBus/';

export default {
  name: 'filter-list',
  props: {
    buttonText: {
      type: String,
    },
    api: {
      type: String,
      required: true,
    },
    currentPage: {
      type: String,
      required: true,
    },
    currentPageTemplate: {
      type: String,
      required: true,
    },
    pageSize: {
      type: String,
      required: true,
    },
    totalProductCount: {
      type: String,
      required: true,
    },
    totalProductCountLabel: {
      type: String,
      default: 'Products',
    },
    pageType: {
      type: String,
      required: true,
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
    keyword: {
      type: String,
      required: false,
      default: '',
    },
    facetList: {
      type: String,
      default: '',
    },
    filterBtn: {
      type: String,
      default: 'Filter',
    },
    filterPage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      items: [],
      pageNbr: 1,
      label: '',
      impressions: [],
      newItems: null,
      loading: false,
      filters: [],
      busName: 'item-grid',
      isFiltersSelected: false,
      totalFilteredResults: null,
      initialItemsLoaded: true,
      isFilterMobileWrapperPresent: false,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    eventBus.$on(`${this.busName}:load`, this.loadMoreProducts);
    eventBus.$on(`${this.busName}:filters`, this.onSelectFilter);
    this.isFilterMobileWrapperPresent = !!document.querySelector('.filter-mobile-wrapper');
  },
  computed: {
    showLoadMoreBtn() {
      if ((this.items.length + Number(this.pageSize)) === Number(this.totalProductCount) || Number(this.totalProductCount) <=11 ){
        return false;
      }
      if (this.filters?.length) {
        return Number(this.totalFilteredResults) > this.items.length;
      } else {
        return this.items.length < Number(this.totalProductCount);
      }
    },
    isProducts() {
      return this.pageType === 'product';
    },
    isArticles() {
      return this.pageType === 'article';
    },
  },
  watch: {
    loading() {
      eventBus.$emit(`${this.busName}:loadingState`, this.loading);
    },
  },
  methods: {
    loadMoreProducts() {
      this.pageNbr = this.pageNbr + 1;
      this.isFiltersSelected = false;
      this.getData();
    },
    getRequestUrl() {
      const queryParams = new URLSearchParams();
      queryParams.set('pagenumber', this.pageNbr);
      queryParams.set('pagesize', this.pageSize);
      queryParams.set('currentpage', this.currentPage);
      queryParams.set('keyword', this.keyword);
      queryParams.set('currentpagetemplate', this.currentPageTemplate);
      queryParams.set('facetList', this.facetList);
      if (!!this.filters && this.filters.length) {
        this.filters.forEach((filter) => {
          queryParams.set(filter.query, filter.filterTag);
        });
      }

      return `${this.api}?${queryParams.toString()}`;
    },
    getData() {
      let api = `${this.getRequestUrl()}`;
      fetch(api)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          this.newItems = null;
          if (this.isArticles) {
            this.newItems = data.Data.Articles.length;
            this.items.push(...data.Data.Articles);
          } else {
            if (this.isFiltersSelected) {
              this.items = [];
            }
            this.totalFilteredResults = data.TotalProductCount;
            this.newItems = data.Data.Products.length;
            this.items.push(...data.Data.Products);

            eventBus.$emit(
              `${this.busName}:total-filters-result`,
              this.totalFilteredResults
            );

            eventBus.$emit(
              `${this.busName}:update-filters`,
              data.Data.facets || []
            );
          }
          this.$nextTick(() => {
            this.loading = false;
            document.body.style.pointerEvents = 'auto';
            this.setFocus();
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setFocus() {
      let elementsCount = this.items.length - this.newItems;
      if (!this.filters?.length && !this.isFiltersSelected) {
        elementsCount += Number(this.pageSize);
      }
      this.$refs.filterList
        .querySelectorAll('.card__content')
        [elementsCount]?.focus();
    },

    onSelectFilter(data) {
      this.pageNbr = 1;
      this.loading = true;
      this.isFiltersSelected = true;
      this.initialItemsLoaded = false;
      this.filters = data;
      this.getData();
    },
  },
};
</script>
